/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyersectiontitle2Inputs */

const en_flyersectiontitle2 = /** @type {(inputs: Flyersectiontitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const de_flyersectiontitle2 = /** @type {(inputs: Flyersectiontitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Flyersectiontitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyersectiontitle2 = /** @type {((inputs?: Flyersectiontitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyersectiontitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyersectiontitle2(inputs)
	return de_flyersectiontitle2(inputs)
});
export { flyersectiontitle2 as "flyerSectionTitle" }